module.exports = __webpack_public_path__ + "img/hr-level3addon_running_gun_mask.c6884d2b.png";